import angular from 'angular';
import uiRouter from 'angular-ui-router';
import surveyComponent from './survey.component';

let surveyModule = angular.module('app.containers.survey', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('survey', {
      url: '/survey',
      template: '<survey></survey>'
    });
})

.component('survey', surveyComponent);

export default surveyModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/survey/survey.js
 **/